import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

const userAllowed = ['apaez@santillana.com', 'mzunigap@unoi.com'];

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user) {
  return {
    readList: canPermissions(user),
    readDetail: canPermissions(user),
    create: canPermissions(user),
    update: canPermissions(user),
    delete: canPermissions(user),

    // TABLE USERS:
    columnAdminSchool: !isThirdPartyIntegrations(user),
  };
}
